/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowRampLeft = createReactComponent("outline", "arrow-ramp-left", "IconArrowRampLeft", [["path", { "d": "M17 3l0 8.707", "key": "svg-0" }], ["path", { "d": "M13 7l4 -4l4 4", "key": "svg-1" }], ["path", { "d": "M7 14l-4 -4l4 -4", "key": "svg-2" }], ["path", { "d": "M17 21a11 11 0 0 0 -11 -11h-3", "key": "svg-3" }]]);

export { IconArrowRampLeft as default };
//# sourceMappingURL=IconArrowRampLeft.mjs.map
